import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Role } from '@umss/shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private getApiUrl(facilityId: string) {
    return `/api/facilities/${facilityId}/roles`;
  }

  constructor(private http: HttpClient) {}

  /**
   * Fetch all roles for a facility.
   * @param facilityId The ID of the facility.
   * @returns An Observable array of Roles.
   */
  getRoles(facilityId: string): Observable<Role[]> {
    return this.http.get<Role[]>(this.getApiUrl(facilityId));
  }

  /**
   * Add a new role to a facility.
   * @param facilityId The ID of the facility.
   * @param roleData The data for the new role.
   * @returns An Observable of the created Role.
   */
  addRole(facilityId: string, roleData: Partial<Role>): Observable<Role> {
    return this.http.post<Role>(this.getApiUrl(facilityId), roleData);
  }

  /**
   * Update an existing role.
   * @param facilityId The ID of the facility.
   * @param roleId The ID of the role to update.
   * @param roleData The partial data for the role to update.
   * @returns An Observable of the updated Role.
   */
  updateRole(
    facilityId: string,
    roleId: number,
    roleData: Partial<Role>
  ): Observable<Role> {
    return this.http.put<Role>(
      `${this.getApiUrl(facilityId)}/${roleId}`,
      roleData
    );
  }

  /**
   * Delete a role from a facility.
   * @param facilityId The ID of the facility.
   * @param roleId The ID of the role to delete.
   * @returns An Observable that completes when the operation is done.
   */
  deleteRole(facilityId: string, roleId: number): Observable<void> {
    return this.http.delete<void>(`${this.getApiUrl(facilityId)}/${roleId}`);
  }
}
